export class SubscriptionDetailJSON {
  subscriptionPlanId: number;
  units?: number;
  stripePriceExternalId?: string;
  // subscriptionPlan?: any; // SubscriptionPlanEntity; // WATCH  SubscriptionPlanEntity is removed from SubscriptionDetailJSON
}
